import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Box, Card, DialogTitle, FormControl, DialogContent, IconButton, MenuItem, Select, Typography, DialogActions, CircularProgress } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import { grey } from '@mui/material/colors';
import { assignProduct, getBoxes } from "../../../redux/slices/hyperwolf/inventoryDistribution";
import { showToastMsg } from "components/distributionSetting/distributionManagement/addRegionKit";
import MDButton from "components/MDButton";

export default function AssignProductToBox({ closeModal }) {
  const dispatch = useDispatch();

  const { modalData } = useSelector(state => state.modal || {});

  const [allBoxes, setAllBoxes] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [boxId, setBoxId] = useState("");
  const [error, setError] = useState("");

  const handleGetBoxes = async () => {
    try {
      const response = await dispatch(getBoxes({ limit: 1000 })).unwrap();
      if (response?.data) {
        setAllBoxes(response?.data || []);
      }
    }
    catch (error) {
      showToastMsg(error, "error");
    }
  };

  const handleSave = async () => {
    try {
      if (isLoading) return;
      if (!boxId) {
        setError("Please select box to assign products")
        return;
      } else {
        setError("")
      }

      setIsLoading(true);
      const { isAllChecked, selectedProducts, customFilters } = modalData || {};

      const request = {
        boxId,
        productIds: isAllChecked ? [] : selectedProducts,
        isAllSelected: isAllChecked,
        ...customFilters
      };
      const response = await dispatch(assignProduct(request)).unwrap();

      if (response?.message) {
        showToastMsg(response?.message || "Success", "success")
        if (modalData?.setRefreshRules) {
          modalData?.setRefreshRules(prev => !prev)
        }
        if (modalData?.setSelectedProducts) {
          modalData?.setSelectedProducts([])
        }
        if (modalData?.handleGetAllProducts) {
          modalData?.handleGetAllProducts()
        }
      };

      showToastMsg(response?.message || "Success", "success");
      closeModal();
    } catch (error) {
      closeModal();
      showToastMsg(error, "error")
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    handleGetBoxes();
  }, []);

  return (
    <Card sx={{ py: 3, px: 4, borderRadius: 0 }}>
      <DialogTitle id='draggable-dialog-title' sx={{ p: 0, mb: 4 }} display='flex' alignItems='center' justifyContent='space-between'>
        Assign Product To Box
        <IconButton onClick={closeModal} edge='end' size='small' className='modal-close'>
          <CloseIcon fontSize='medium' />
        </IconButton>
      </DialogTitle>

      <DialogContent>
        <Box>
          <Typography variant='body2' fontWeight="medium" color={grey[600]} mb={1}>Select Box</Typography>
          <FormControl fullWidth>
            <Select
              size='small'
              fullWidth
              className='form-select select-field-icon'
              name='boxId'
              value={boxId}
              onChange={e => setBoxId(e.target.value)}
              MenuProps={{
                classes: {
                  root: "cus-dropdown-height",
                }
              }}
            >
              {allBoxes?.map(box => (
                <MenuItem key={box?._id} value={box?._id}>{box?.name}</MenuItem>
              ))}
            </Select>
            {error && <p className="error">{error}</p>}
          </FormControl>
        </Box>
      </DialogContent>

      <DialogActions>
        <MDButton
          color="primary"
          type="button"
          variant="contained"
          disabled={isLoading}
          onClick={handleSave}
        >
          {isLoading ? <CircularProgress size={22} color="light" /> : "Save"}
        </MDButton>
        <MDButton
          onClick={closeModal}
          type='button'
          variant='outlined'
          color='dark'
        >
          Cancel
        </MDButton>
      </DialogActions>
    </Card>
  )
}